import styled from 'styled-components'

export const SubscriptionCard = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100%;
  padding: 24px;

  & > button {
    margin: 24px auto 24px;
    max-height: 40px;
    max-width: 215px;
    padding: 10px;
  }

  .link {
    text-decoration: underline;
  }
`

export const BrandContainer = styled.div`
  max-width: 135px;
  margin: 0 auto 24px;
`
export const FeaturedImageContainer = styled.div`
  max-width: 286px;
  max-height: 100px;
  margin: 0 auto 32px;
`
